/**
 * Initializes menu item hover effects.
 * Adds 'hovered' class to menu items and their parents on hover,
 * and removes it when the mouse leaves, ensuring no parent remains
 * hovered if none of its children are being hovered.
 */
export function initNavigationHoverEffects() {
  $('[class*="menu-item"], .hoverable').hover(
    function() {
      $(this).addClass('hovered');
      $(this).parents('[class*="menu-item"]').addClass('hovered');
    },
    function() {
      if (!$(this).find(':hover').length) {
        $(this).removeClass('hovered');
        $(this).parents('[class*="menu-item"]').each(function() {
          if (!$(this).find(':hover').length) {
            $(this).removeClass('hovered');
          }
        });
      }
    }
  );
}